import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';
import MindsLogLogo from '../assets/MindsLogLogo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'Home', path: '/home' }, 
    { label: 'Opportunities', path: '/' }, 
    { label: 'Upskill', path: '/academy' },
    { label: 'AI News & Trends', path: '/insights' },
    { label: 'Top AI Companies', path: '/directory' },
    { label: 'Our Mission', path: '/about-us' },
    { label: 'Connect', path: '/contact-us' },
    { label: 'Agreement', path: '/agreement' },
    { label: 'Games', path: '/games' }
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="bg-white/90 backdrop-blur-md py-3 shadow-sm sticky top-0 z-[100] border-b border-slate-200">
      <div className="max-w-[1500px] mx-auto px-5 flex items-center justify-between">
        
        {/* 1. Logo Section */}
        <div className="flex items-center gap-3">
          <Link to="/" onClick={closeMenu}>
            <img
              src={MindsLogLogo}
              alt="MindsLog Logo"
              className="h-9 w-auto hover:opacity-80 transition-opacity"
            />
          </Link>
        </div>

        {/* 2. Desktop Navigation (Hidden on Mobile) */}
        <nav className="hidden lg:flex items-center gap-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`font-bold text-[13px] uppercase tracking-wider px-4 py-2 rounded-lg transition-all duration-200 
                  ${isActive 
                    ? 'text-blue-600 bg-blue-50' 
                    : 'text-slate-600 hover:text-blue-600 hover:bg-slate-50' 
                  }`}
              >
                {item.label}
              </Link>
            );
          })}
          <button className="ml-4 bg-slate-900 text-white px-6 py-2.5 rounded-full text-[12px] font-black uppercase tracking-widest hover:bg-blue-600 transition-all shadow-lg shadow-slate-200">
            Get Started
          </button>
        </nav>

        {/* 3. Mobile Hamburger Button (Visible on Mobile Only) */}
        <button
          onClick={toggleMenu}
          className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-xl transition-colors focus:outline-none"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* 4. MOBILE DROPDOWN MENU */}
      {/* This section animates down when isMenuOpen is true */}
      <div className={`
        lg:hidden absolute top-full left-0 w-full bg-white border-b border-slate-200 shadow-xl transition-all duration-300 ease-in-out overflow-hidden
        ${isMenuOpen ? 'max-h-[600px] opacity-100 visible' : 'max-h-0 opacity-0 invisible'}
      `}>
        <nav className="flex flex-col p-4 bg-white">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={closeMenu} // Closes menu when a link is clicked
                className={`flex items-center justify-between p-4 rounded-xl font-bold text-sm transition-all mb-1
                  ${isActive 
                    ? 'bg-blue-600 text-white shadow-md' 
                    : 'text-slate-600 hover:bg-slate-50'
                  }`}
              >
                {item.label}
                <ChevronRight size={18} className={isActive ? 'text-white' : 'text-slate-300'} />
              </Link>
            );
          })}
          
          <div className="mt-4 p-2">
            <button className="w-full bg-slate-900 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl shadow-slate-200">
              Get Started Now
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;